import { Dropdown } from '@/components/dropdown/dropdown'
import { useCartStore } from '@/stores/cart-store/cartStore'
import { translate } from '@/utils/translator'

const GERMAN_STATES = [
	{ label: 'Baden-Württemberg', value: 'Baden-Württemberg' },
	{ label: 'Bayern', value: 'Bayern' },
	{ label: 'Berlin', value: 'Berlin' },
	{ label: 'Brandenburg', value: 'Brandenburg' },
	{ label: 'Bremen', value: 'Bremen' },
	{ label: 'Hamburg', value: 'Hamburg' },
	{ label: 'Hessen', value: 'Hessen' },
	{ label: 'Mecklenburg-Vorpommern', value: 'Mecklenburg-Vorpommern' },
	{ label: 'Niedersachsen', value: 'Niedersachsen' },
	{ label: 'Nordrhein-Westfalen', value: 'Nordrhein-Westfalen' },
	{ label: 'Rheinland-Pfalz', value: 'Rheinland-Pfalz' },
	{ label: 'Saarland', value: 'Saarland' },
	{ label: 'Sachsen', value: 'Sachsen' },
	{ label: 'Sachsen-Anhalt', value: 'Sachsen-Anhalt' },
	{ label: 'Schleswig-Holstein', value: 'Schleswig-Holstein' },
	{ label: 'Thüringen', value: 'Thüringen' },
]

export const TravelPeriodHolidays = () => {
	const { federalState } = useCartStore.use.travelPeriod()
	const setSelectedFederalState = useCartStore.use.setFederalState()

	return (
		<Dropdown
			options={[
				{ label: translate('travel-period-holiday-placeholder'), value: 'reset' },
				...GERMAN_STATES,
			]}
			value={federalState}
			onUpdate={setSelectedFederalState}
			placeholder={translate('travel-period-holiday-placeholder')}
			inverted
		/>
	)
}
